<script lang="ts">
  import type { Color, PromotionType } from '@blind-chess/shared';

  interface Props {
    color: Color;
    onChoose: (p: PromotionType) => void;
    onCancel: () => void;
  }
  let { color, onChoose, onCancel }: Props = $props();

  const glyphs: Record<PromotionType, { w: string; b: string; name: string }> = {
    q: { w: '♕', b: '♛', name: 'Queen' },
    r: { w: '♖', b: '♜', name: 'Rook' },
    b: { w: '♗', b: '♝', name: 'Bishop' },
    n: { w: '♘', b: '♞', name: 'Knight' },
  };
</script>

<div class="overlay" role="dialog" aria-modal="true" aria-label="Choose promotion">
  <div class="card">
    <h3>Promote pawn</h3>
    <div class="row">
      {#each Object.entries(glyphs) as [k, g] (k)}
        <button class="choice" onclick={() => onChoose(k as PromotionType)}>
          <span class="glyph piece-{color}">{color === 'w' ? g.w : g.b}</span>
          <span class="lbl">{g.name}</span>
        </button>
      {/each}
    </div>
    <button class="cancel" onclick={onCancel}>Cancel</button>
  </div>
</div>

<style>
  .overlay {
    position: fixed; inset: 0;
    background: rgba(0,0,0,0.6);
    display: flex; align-items: center; justify-content: center;
    z-index: 100;
  }
  .card {
    background: var(--panel);
    border: 1px solid var(--border);
    border-radius: 10px;
    padding: 18px;
    max-width: 360px;
    width: 92vw;
  }
  h3 { margin: 0 0 14px; }
  .row {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
    margin-bottom: 12px;
  }
  .choice {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 12px 4px;
    background: var(--panel-2);
  }
  .glyph { font-size: 36px; line-height: 1; }
  .piece-w { color: #fafafa; text-shadow: 0 1px 2px rgba(0,0,0,0.5); }
  .piece-b { color: #1a1a1a; text-shadow: 0 1px 1px rgba(255,255,255,0.3); background: var(--light); border-radius: 4px; padding: 2px 6px; }
  .lbl { font-size: 12px; margin-top: 4px; color: var(--text-dim); }
  .cancel { width: 100%; }
</style>
